import Mutations from '../../odata/mutations';

export default { ...new Mutations('orgSetting'), ...new Mutations('orgSettings') };
